import { Module } from "../plugins/_application";
import $ from 'jquery';

export default class SmoothScroll extends Module {
	ready(app) {
    $(document).on('click', 'a[href*="#"]', function(event) {
      if ($(event.target).is('[href="#"]') || $(event.target).is('[href="#0"]')) {
        return false;
      }

      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          event.preventDefault();
          var navigationHeight = $('#main_header').height();

          $('html, body').animate({
            scrollTop: target.offset().top - navigationHeight
          }, 750, function() {
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              return false;
            } else {
              $target.attr('tabindex','-1');
              $target.focus();
            }
          });
        }
      }
    });
  }
}